import {
  RequestError,
  type PopupProps,
  SurvivalMode as SurvivalModePopup
} from '@CS/components/Popups';

import Store from '@/redux';
import API from '@/services/api';
import { MCD } from '@/services/app';
import { connect } from 'react-redux';
import type { AxiosError } from 'axios';

import { useState, useEffect } from 'react';
import { setUserPoints } from '@/redux/user/actions';
import type { EntityData, RequestErrorInfo } from '@/services/api/types';
import { getUserEntityData, getUserPoints } from '@/redux/user/selectors';

type SurvivalModeProps = PopupProps & {
  onConfirm?: () => void;
  onCancel?: () => void;
  userData?: EntityData;
  onClose: () => void;
  maxUse?: number;
  points: number;
  score?: number;
  price: number;
};

const SurvivalMode = ({
  maxUse = Infinity,
  onConfirm,
  userData,
  points,
  price,
  ...props
}: SurvivalModeProps) => {
  const { onCancel = () => void 0, onClose } = props;
  let survivalModes = (userData?.survivalModes ?? 0) as number;
  const cancelSurvivalMode = () => setSurvivalModeError(undefined);

  const [survivalModeError, setSurvivalModeError] =
    useState<RequestErrorInfo>();

  const onSubmit = async () => {
    onConfirm?.();
    survivalModes++;

    Promise.all([
      MCD.burnUserPoints(price),
      API.updateUser({ data: { survivalModes } })
    ])
      .then(() => Store.dispatch(setUserPoints(points - price)))
      .catch(error => {
        setSurvivalModeError(API.getRequestErrorInfo(error as AxiosError));
        throw error;
      });
  };

  useEffect(() => {
    if (survivalModes === maxUse) {
      onCancel();
      onClose();
    }
  }, [maxUse]);

  return (
    <>
      <SurvivalModePopup
        onSubmit={onSubmit}
        onCancel={onCancel}
        points={points}
        price={price}
        {...props}
      />

      {survivalModeError && (
        <RequestError info={survivalModeError} onClose={cancelSurvivalMode} />
      )}
    </>
  );
};

const mapStateToProps = (state: never) => ({
  userData: getUserEntityData(state),
  points: getUserPoints(state)
});

export default connect(mapStateToProps)(SurvivalMode);
